import { ApiService } from "./ApiService";
import { HistoryCoverDTO } from "Types/Admin/HistoryCoverDTO";
import { ResultsDTO } from "Types/ResultsDTO";

export interface HistoryCover {
  id: number;
  plant: string;
  title: string;
  description1?: string;
  description2?: string;
  description3?: string;
  coverImageUrl?: string;
}

export const HistoryCoverApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllHistoryCover: builder.query<HistoryCover[], { plant: string }>({
      query: ({ plant }) => ({
        url: "/history-cover/getAll",
        method: "GET",
        params: { plant },
      }),
      transformResponse: (res: ResultsDTO<HistoryCover[]>) => res.results ?? [],
      providesTags: ["HistoryCover"],
    }),

    saveHistoryCover: builder.mutation<ResultsDTO, { data: HistoryCoverDTO; file?: File | null }>({
      query: ({ data, file }) => {
        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
        if (file) {
          formData.append("file", file);
        } else {
          formData.append("file", new Blob());
        }
        return { url: "/history-cover/save", method: "POST", body: formData };
      },
      invalidatesTags: ["HistoryCover"],
    }),

    updateHistoryCover: builder.mutation<ResultsDTO, { data: HistoryCoverDTO; file?: File | null }>({
      query: ({ data, file }) => {
        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
        if (file) {
          formData.append("file", file);
        } else {
          formData.append("file", new Blob());
        }
        return { url: "/history-cover/update", method: "PUT", body: formData };
      },
      invalidatesTags: ["HistoryCover"],
    }),

    deleteHistoryCover: builder.mutation<ResultsDTO, { id: number; plant: string }>({
      query: ({ id, plant }) => ({
        url: "/history-cover/delete",
        method: "DELETE",
        params: { id, plant },
      }),
      invalidatesTags: ["HistoryCover"],
    }),

    deleteHistoryCoverImage: builder.mutation<ResultsDTO, { id: number; plant: string }>({
      query: ({ id, plant }) => ({
        url: "/history-cover/delete-image",
        method: "DELETE",
        params: { id, plant },
      }),
      invalidatesTags: ["HistoryCover"],
    }),
  }),
});

export const {
  useGetAllHistoryCoverQuery,
  useSaveHistoryCoverMutation,
  useUpdateHistoryCoverMutation,
  useDeleteHistoryCoverMutation,
  useDeleteHistoryCoverImageMutation,
} = HistoryCoverApiSlice;
